import {
  Activity,
  Bot,
  Brain,
  Cable,
  ClipboardList,
  FileSpreadsheet,
  Gauge,
  GitCompareArrows,
  HeartPulse,
  History,
  LayoutDashboard,
  Package,
  Puzzle,
  BookOpen,
  Sparkles,
  ScanSearch,
  Search,
  Settings,
  Settings2,
  Table2,
  Target,
  Truck,
  Users,
  WalletCards,
  Workflow,
  BriefcaseBusiness,
} from 'lucide-react'

import { APP_VERSION as PACKAGE_APP_VERSION } from '@/config/version'
import type { NavItem } from '@/types'

export const APP_NAME = 'MasterHub Smart Budget'
export const APP_SHORT_NAME = 'MasterHub'
export const APP_TAGLINE = 'Plataforma inteligente para lojas de informática'
/** Re-export — version source of truth is `package.json` (via `@/config/version`). */
export const APP_VERSION = PACKAGE_APP_VERSION

export const navigationItems: NavItem[] = [
  { title: 'Dashboard', href: '/', icon: LayoutDashboard },
  { title: 'Clientes', href: '/clientes', icon: Users },
  { title: 'Produtos', href: '/produtos', icon: Package },
  { title: 'Master Search', href: '/search', icon: Search },
  { title: 'Comparador', href: '/comparador', icon: GitCompareArrows },
  { title: 'Comparador Inteligente', href: '/comparador-inteligente', icon: Table2 },
  { title: 'Quote Builder PRO', href: '/orcamentos/pro', icon: FileSpreadsheet },
  { title: 'Quote Experience', href: '/orcamentos/workspace', icon: BriefcaseBusiness },
  { title: 'Solution Builder', href: '/solution-builder', icon: Puzzle },
  { title: 'Knowledge Base', href: '/knowledge-base', icon: BookOpen },
  { title: 'Recomendações', href: '/recomendacoes', icon: Sparkles },
  { title: 'Otimizador', href: '/otimizador', icon: WalletCards },
  { title: 'IA Comercial', href: '/ia', icon: Brain },
  { title: 'Sales Workbench', href: '/sales-workbench', icon: Workflow },
  { title: 'Settings Center', href: '/settings', icon: Settings2 },
  { title: 'Integration Center', href: '/integrations', icon: Cable },
  { title: 'System Status', href: '/system', icon: HeartPulse },
  { title: 'Product Intelligence', href: '/inteligencia-produto', icon: ScanSearch },
  { title: 'Novo Orçamento', href: '/orcamentos/editor', icon: ClipboardList },
  { title: 'Histórico', href: '/historico', icon: History },
  { title: 'Painel de Oportunidades', href: '/oportunidades', icon: Target },
  { title: 'Motor de Precificação', href: '/configuracoes/precificacao', icon: Gauge },
  { title: 'Fornecedores', href: '/configuracoes/fornecedores', icon: Truck },
  { title: 'Integrações', href: '/configuracoes/integracoes', icon: Activity },
  { title: 'Automações', href: '/configuracoes/automacoes', icon: Bot },
  { title: 'Configurações', href: '/configuracoes', icon: Settings },
]
